const IMPERSONATE_KEY = 'impersonateEmail';

export function setImpersonateEmail(email) {
  if (email) {
    sessionStorage.setItem(IMPERSONATE_KEY, email);
  } else {
    sessionStorage.removeItem(IMPERSONATE_KEY);
  }
}

export function getImpersonateEmail() {
  return sessionStorage.getItem(IMPERSONATE_KEY);
}
